import axios from 'axios';
import { axiosInstance } from '../clients/axiosClient';
import {
  AUTH0_DOMAIN,
  AUTH0_CLIENT_ID,
  API_V1_PREFIX,
  AUTH_API_PREFIX,
  AUTH0_AUDIENCE
} from '../utils/constants';
import { TokenResponse } from '../types/apiGeneratedTypes';

export const sendMagicLinkToEmail = async (email: string) => {
  try {
    const { data } = await axios.post(`${AUTH0_DOMAIN}/passwordless/start`, {
      client_id: AUTH0_CLIENT_ID,
      connection: 'email',
      email,
      send: 'link',
      authParams: {
        redirect_uri: window.location.origin,
        audience: AUTH0_AUDIENCE,
        scope: 'openid profile phone email'
      }
    });

    return data;
  } catch (error) {
    return error;
  }
};

export const getTokenPair = async (
  auth0Token: string
): Promise<TokenResponse> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${AUTH_API_PREFIX}login`,
      null,
      {
        headers: {
          Authorization: 'Bearer ' + auth0Token
        }
      }
    );

    return data;
  } catch (error: any) {
    return error;
  }
};

export const getNewTokenPair = async (
  refresh_token: string
): Promise<TokenResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${AUTH_API_PREFIX}token`,
      {
        headers: {
          Authorization: 'Bearer ' + refresh_token
        }
      }
    );
    return data;
  } catch (error: any) {
    return error;
  }
};
